'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../../validators/common/PropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a component which can hide its children.
 * @extends {Component}
 */
var HiderComponent = function (_React$Component) {
  _inherits(HiderComponent, _React$Component);

  function HiderComponent() {
    _classCallCheck(this, HiderComponent);

    return _possibleConstructorReturn(this, (HiderComponent.__proto__ || Object.getPrototypeOf(HiderComponent)).apply(this, arguments));
  }

  _createClass(HiderComponent, [{
    key: 'render',
    value: function render() {
      return this.props.isHidden ? null : this.props.children;
    }
  }]);

  return HiderComponent;
}(_react2.default.Component);

HiderComponent.propTypes = {
  isHidden: _react2.default.PropTypes.bool,
  children: _PropTypes.REACT_CHILDREN
};
HiderComponent.defaultProps = {
  isHidden: false
};
exports.default = HiderComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/HiderComponent.jsx
// module id = 810
// module chunks = 0